export const CUBE = {
  WIDTH: 1,
  DEPTH: 1,
  HEIGHT: 1,
  MIN_DIMENSION: 0.01,
  COLOR: 0xffffff,
};

export const SPHERE = {
  RADIUS: 0.5,
  MIN_RADIUS: 0.01,
  WIDTH_SEGMENTS: 32,
  HEIGHT_SEGMENTS: 32,
  MIN_SEGMENTS: 3,
  PHI_START: 0,
  PHI_LENGTH: Math.PI * 2,
  THETA_START: 0,
  THETA_LENGTH: Math.PI,
  MIN_ANGLE: 0,
  COLOR: 0xffffff,
};

export const CYLINDER = {
  RADIUS_TOP: 0.5,
  RADIUS_BOTTOM: 0.5,
  MIN_RADIUS: 0.01,
  HEIGHT: 1,
  MIN_HEIGHT: 0.01,
  RADIAL_SEGMENTS: 32,
  MIN_RADIAL_SEGMENTS: 3,
  COLOR: 0xffffff,
};

export const PLANE = {
  WIDTH: 1,
  HEIGHT: 1,
  MIN_DIMENSION: 0.01,
  COLOR: 0xffffff,
};

export const TORUS_KNOT = {
  RADIUS: 1,
  MIN_RADIUS: 0.01,
  TUBE: 0.3,
  MIN_TUBE: 0.01,
  RADIAL_SEGMENTS: 16,
  MIN_RADIAL_SEGMENTS: 3,
  TUBULAR_SEGMENTS: 64,
  MIN_TUBULAR_SEGMENTS: 32,
  COLOR: 0xffffff,
};
const ORTHO_CAMERA_FRUSTUM_SIZE = 15;
const ORTHO_CAMERA_HALF = ORTHO_CAMERA_FRUSTUM_SIZE / 2;
export const CAMERA = {
  ORTHO_CAMERA_FRUSTUM_SIZE,
  DEFAULT_CAMERA_POSITION: { x: -4.38, y: 4.86, z: 14.04 },
  DEFAULT_CAMERA_TARGET: { x: 0, y: 0, z: 0 },
  DEFAULT_CAMERA_ZOOM: 1,
  PERSPECTIVE_CAMERA_FOV: 55,
  PERSPECTIVE_CAMERA_ASPECT: 1,
  CAMERA_NEAR: 0.01,
  CAMERA_FAR: 1000,
  DEFAULT_ORTHO_CAMERA_POSITION: { x: 0, y: 2, z: 5 },
  ORTHO_CAMERA_LEFT: -ORTHO_CAMERA_HALF,
  ORTHO_CAMERA_RIGHT: ORTHO_CAMERA_HALF,
  ORTHO_CAMERA_TOP: ORTHO_CAMERA_HALF,
  ORTHO_CAMERA_BOTTOM: -ORTHO_CAMERA_HALF,
  ORTHO_CAMERA_NEAR: 0.1,
  CAMERA_ROTATE_SPEED: 1.0,
  CAMERA_DRAGGING_SMOOTH_TIME: 0,
  CAMERA_DOLLY_SPEED: 1.0,
  CAMERA_SMOOTH_TIME: 0.25,
  CAMERA_DOLLY_TO_CURSOR: true,
  CAMERA_MIN_DISTANCE: 1,
  CAMERA_MAX_DISTANCE: 900,
  CAMERA_MIN_ZOOM: 0.1,
  CAMERA_MAX_ZOOM: 100,
};

export const DIRECTIONAL_LIGHT = {
  ENABLED: true,
  INTENSITY: 0.3,
  YAW: 45,
  PITCH: 45,
};

export const AMBIENT_LIGHT = {
  ENABLED: true,
  INTENSITY: 0.03,
};

export const OBJECT_EDGES = {
  SHOW: false,
  COLOUR: '#ffffff',
  THICKNESS: 1,
  SELECTION_COLOR: '#D2E03F',
};

export const GROUND_TOLERANCE = 0.001;

export const GEOMETRY_TYPES = ['cube', 'box', 'sphere', 'plane', 'cylinder', 'torusknot'];

export const SUPPORTED_IMAGE_FORMATS = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
export const SUPPORTED_VIDEO_FORMATS = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv'];
export const SUPPORTED_3D_FORMATS = ['obj', 'fbx', 'gltf', 'glb', 'dae', '3ds', 'ply'];
export const SUPPORTED_3D_FORMATS_LABEL = SUPPORTED_3D_FORMATS.map((f) => f.toUpperCase()).join(', ');
export const SUPPORTED_PROJECTOR_MESH_FORMATS_LABEL = 'OBJ, ZIP (containing OBJ or Three.js JSON)';

export const PROJECTOR = {
  MIN_THROW_RATIO: 0.5,
  MAX_THROW_RATIO: 6.0,
  DEFAULT_THROW_RATIO: 1.4,
};
export const FRUSTUM_LIGHT = {
  COLOR: 0x86e6ff,
  OPACITY: 0.05,
  RENDER_ORDER: 998,
  SIDE: 'DoubleSide',
  DEPTH_WRITE: false,
  DEPTH_TEST: false,
  TRIANGLES: 4,
};

export const LED_SCREEN = {
  HORIZONTAL_SIZE: 10,
  VERTICAL_SIZE: 6,
  TILE_WIDTH: 0.5,
  TILE_HEIGHT: 0.5,
  TOTAL_WIDTH: 5, // TILE_WIDTH × HORIZONTAL_SIZE
  TOTAL_HEIGHT: 3, // TILE_HEIGHT × VERTICAL_SIZE
  RESOLUTION_WIDTH: 1920,
  RESOLUTION_HEIGHT: 1080,
  HORIZONTAL_CURVATURE: 0,
  VERTICAL_CURVATURE: 0,
  BRIGHTNESS: 100,
  SPACING: 0,
  DIMENSION_STEP: 0.1,
  DIMENSION_MIN: 0.1,
};
